// @dynamic-i18n-keys
// Dynamic t() at line 44 (isMobile suffix):
//   deviationSubmit.form.labelOptions.createdWithAI
//   deviationSubmit.form.labelOptions.createdWithAI.mobile
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useTranslation } from 'react-i18next';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { useSubmitField } from '../../../hooks/useSubmitField';
import { SubmitFormContext } from '../../../context';

interface Props {
  className?: string;
  noBottomSpacing?: boolean;
}

const FIELD_NAME = 'isAiGenerated';

const CreatedWithAiCheckboxField: React.FC<Props> = ({
  className,
  noBottomSpacing,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { initResponse } = useContext(SubmitFormContext)!;
  const { canUpdateAiClaim } = initResponse?.deviation ?? {};

  const {
    id,
    field: { onChange, value },
  } = useSubmitField(FIELD_NAME, {
    initAdapter: ({ deviation }) =>
      deviation?.canUpdateAiClaim ? (deviation.isAiGenerated ?? false) : true,
    submitAdapter: data => ({
      is_ai_generated: !!data.isAiGenerated,
    }),
  });

  return (
    <BooleanInput
      className={className}
      name={FIELD_NAME}
      id={id}
      value={value}
      onChange={onChange}
      type="checkbox"
      size="large"
      label={t(
        `deviationSubmit.form.labelOptions.createdWithAI${
          isMobile ? '.mobile' : ''
        }`
      )}
      disabled={!canUpdateAiClaim}
      noBottomSpacing={noBottomSpacing}
    />
  );
};
CreatedWithAiCheckboxField.displayName = 'CreatedWithAiCheckboxField';

export default CreatedWithAiCheckboxField;
